import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpParams } from '@angular/common/http';

import { Store } from '@ngrx/store';
import { take, map, exhaustMap } from 'rxjs/operators';

import { AppState, getMyAuth } from '../store/app.state';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  /**
   * Costruttore dell'interceptor
   * @param store {Store<AppState>} stato dell'applicazione
   */
  constructor(
    private store: Store<AppState>
  ) { }

  /**
   * Metodo dell'interfaccia HttpInterceptor che aggiunge ad ogni richiesta http un parametro contenente la chiave di identificazione temporanea utente
   * @param req {HttpRequest<any>}
   * @param next {HttpHandler}
   */
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return this.store.select(getMyAuth).pipe(
      take(1),
      map(authState => authState.loggedUser),
      exhaustMap(utente => {
        if (!utente) {
          return next.handle(req);
        }
        let modifiedReq;
        if (req.url.indexOf('LexO-backend-beta/service/lexicon/creation/lexicalEntry') !== -1) {
          modifiedReq = req.clone({
            params: new HttpParams().set('key', 'PRINitant19').set('author', utente.username)
          });
        }  else if(req.url.match(new RegExp(/LexO-backend-beta\/service\/lexicon\/data\/(.)+\/lexicalSense/))) {
          modifiedReq = req.clone({
            params: new HttpParams().set('key', utente.key).set('aspect', 'core')
          });
                } else {
          modifiedReq = req.clone({
            params: new HttpParams().set('key', utente.key)
          });
        }        
        return next.handle(modifiedReq);
      })
    );
  }
}
